"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    "report-table": require("./elements/Table.vue").default
  },

  props: ["item"],

  data: function data() {
    return {
      tableHeader: ["", "", "Lower than normal", "Normal", "Over than normal"]
    };
  },

  methods: {
    getDataForTable: function getDataForTable(data) {
      return data.map(function (item) {
        return [item.name, item.groupName, item.lowerStats, item.normalStats, item.upperStats];
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/tables/CompareReferenceTable.vue
// module id = iMFQ
// module chunks = 0 1